const SET_STATE_QUERY_PARAMS = 'SET_STATE_QUERY_PARAMS';

const updateStateParams = (params) => {
	return {
		type: SET_STATE_QUERY_PARAMS,
		params
	}
};

export const storeQueryParams = () => {
	return dispatch => {
		const urlFragment = window.location.search || window.location.hash;
		const queryFragment = urlFragment && urlFragment.split('?')[1];
		const queryParts = queryFragment && queryFragment.split('&');
		const queryParams = {};

		if (queryParts) {
			queryParts.forEach(parts => {
				let query = parts.split('=');
				queryParams[query[0]] = decodeURIComponent(query[1]);
			});

			Object.keys(queryParams).forEach(key => {
				const sessionKey = `queryParam-${key}`;

				// set query param value in session storage if item does not exist in session storage or item does exist but
				// the current query param value differs from what is in session storage
				if (!sessionStorage[sessionKey] || (sessionStorage[sessionKey] && queryParams[key] !== sessionStorage[sessionKey])) {
					sessionStorage.setItem(sessionKey, queryParams[key]);
				}
			});
		} else {
			// get all storage keys with prefix 'queryParam-' and add to the object to be stored on Redux state
			const storedParams = Object.keys(sessionStorage).filter(key => key.indexOf('queryParam-') !== -1);
			storedParams.forEach(param => queryParams[param.split('-')[1]] = sessionStorage[param]);
		}

		dispatch(updateStateParams(queryParams));
	}
};